module.exports = __webpack_public_path__ + "static/media/property.bddd203d.svg";